export enum AtticAmenagment {
    Unknown,
    Converted,
    NotConverted
}